import React from 'react';
import definicoescliente from '../../definicoes-cliente.json';

// Textos e dados do formulário como constantes
const textData = {
  Titulo: 'FÁCIL, RÁPIDA E SEM BUROCRACIA',
  Texto: 'Carro, Moto e Caminhão. Até 100% da tabela FIPE',
  TextoBotao: 'Cotação Online'
};

const Cotacao = () => {
  return (
    <div id="cotacao-online" 
      className="mx-auto px-5 overflow-x-hidden lg:overflow-x-visible bg-theme-primary"
      style={{
        height: '400px',
      }}>      
    <section className="flex items-center h-full p-4">
    {/* Seção do texto */}
    <div className="text-center mx-auto">
      <h1 className="text-textotituloprincipal font-bold text-theme-light-primary">
        {definicoescliente?.Cotacao?.Titulo || textData.Titulo}
      </h1>
      <p className="text-textotitulo mt-4 text-theme-light-primary">
        {definicoescliente?.Cotacao?.Descricao || textData.Texto}
      </p>
      <button
        type="submit"
        className="mt-6 w-full max-w-[200px] uppercase text-textopadrao bg-theme-secondary px-4 py-2 text-theme-light-secondary rounded shadow-md hover:filter hover:brightness-90 border-2 border-transparent cursor-pointer transition duration-200">
          <a href={definicoescliente.Cotacao.LinkBotao || textData.TextoBotao} target="_blank" rel="noopener noreferrer">
            {definicoescliente.Cotacao.NomeBotao || textData.TextoBotao}
          </a>
      </button>
    </div>
  </section>
    </div>
  );
};

export default Cotacao;
